export default function UnitScopeTabs({ unidades, value, onChange }) {
  const tabs = [
    { key: "global", label: "Global", color: "bg-neutral-950 text-white", testid: "scope-global" },
    ...unidades.map((u) => ({
      key: u.id,
      label: u.nome,
      color:
        u.slug === "santa_clara"
          ? "bg-blue-600 text-white"
          : u.slug === "lacador"
          ? "bg-red-600 text-white"
          : "bg-neutral-900 text-white",
      testid: `scope-${u.slug}`,
    })),
  ];

  return (
    <div className="flex gap-2 mb-6 overflow-x-auto">
      {tabs.map((t) => {
        const active = value === t.key;
        return (
          <button
            key={t.key}
            data-testid={t.testid}
            onClick={() => onChange(t.key)}
            className={`h-11 px-5 font-display font-bold uppercase text-xs tracking-widest border-2 border-neutral-900 transition-all whitespace-nowrap ${
              active
                ? `${t.color} shadow-brutal-sm`
                : "bg-white text-neutral-900 hover:bg-neutral-100"
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
